<p>tools-dashboard works!</p>
FREE TOOLS 
WEB RESUME
matrix.tools/(your name) (don't allow special chars) don't allow routes that are already taken (worry about later)? don't allow dupes
job title position
UPLOAD PDF OR DOCX -> upload file (to db?? how to do this??)

VIEW YOUR RESUME ->

UPCOMING NEXT TOOL?


show warnings?  generate a new page when?  as soon as the db record is created?
allow one without a resume uploaded at all -> then work on the file upload.  first just name and position

SAVE and GENERATE btn ->
send in a param as the /routes

matrix.tools/resume -> create this page with keywords and teaser -> FREE RESUME TEASERS
matrix.tools/resume/booth.jesse
matrix.tools/resume/jesse.booth